// extracted by mini-css-extract-plugin
export var callCard = "_p2-0";
export var callMessageButton = "_p2-1";
export var helpIcon = "_p2-3";
export var helpIconContainer = "_p2-4";
export var verticalDivider = "_p2-2";